module.exports = __webpack_public_path__ + "static/img/icon_wifi mall@2x.9cd5853a.png";